import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../api/axios';
import { api } from '../api';

const AffiliateContext = createContext();

export const useAffiliate = () => {
  const context = useContext(AffiliateContext);
  if (!context) {
    throw new Error('useAffiliate must be used within an AffiliateProvider');
  }
  return context;
};

export const AffiliateProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [affiliateData, setAffiliateData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // On mount, set token in axios if it exists
    const token = localStorage.getItem('affiliateToken');
    if (token) {
      axiosInstance.defaults.headers.common['Authorization'] = `Token ${token}`;
      //console.log('[AffiliateContext] Set token in axios on mount:', token);
      //console.log('[AffiliateContext] Axios headers:', axiosInstance.defaults.headers.common);
    }
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    setLoading(true);
    const { authenticated, data } = await api.checkAuth();
    setIsAuthenticated(authenticated);
    setAffiliateData(data);
    setLoading(false);
  };

  const login = async (email, password) => {
    try {
      const data = await api.login(email, password);

      if (data.success) {
        localStorage.setItem('affiliateToken', data.token);
        setIsAuthenticated(true);
        setAffiliateData(data.user);
        return true;
      }

      return false;
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('affiliateToken');
    delete axiosInstance.defaults.headers.common['Authorization'];
    setIsAuthenticated(false);
    setAffiliateData(null);
    navigate('/affiliate/login');
  };

  const value = {
    isAuthenticated,
    affiliateData,
    loading,
    login,
    logout,
    checkAuthStatus,
  };

  return <AffiliateContext.Provider value={value}>{children}</AffiliateContext.Provider>;
};
